import difference from 'lodash/difference';

import type { CustomizationDataShapes, CustomizationItem } from '../../types';
import { createDefaultCustomizationItems } from '../create-default-customization-items';
import { getMenuIdsByVisible } from '../get-menu-ids-by-visible';
import { repairItems } from '../repair-items';

export const buildCustomizationDataShapes = (
	defaultItemMenuIds: string[],
	defaultShortcutMenuIds: string[],
	rawCustomizationData: CustomizationItem[] | null | undefined,
): CustomizationDataShapes => {
	const repairedDefaultItemMenuIds = difference(defaultItemMenuIds, defaultShortcutMenuIds);

	const itemCustomizationData = repair(rawCustomizationData, repairedDefaultItemMenuIds);
	const shortcutCustomizationData = repair(rawCustomizationData, defaultShortcutMenuIds);
	const customizationData = itemCustomizationData.concat(shortcutCustomizationData);

	const [visibleItemMenuIds, hiddenItemMenuIds] = getMenuIdsByVisible(itemCustomizationData);
	const [visibleShortcutMenuIds, hiddenShortcutMenuIds] =
		getMenuIdsByVisible(shortcutCustomizationData);
	const visibleMenuIds = visibleItemMenuIds.concat(visibleShortcutMenuIds);
	const hiddenMenuIds = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);

	return {
		customizationData,
		visibleMenuIds,
		hiddenMenuIds,
		itemCustomizationData,
		visibleItemMenuIds,
		hiddenItemMenuIds,
		shortcutCustomizationData,
		visibleShortcutMenuIds,
		hiddenShortcutMenuIds,
	};
};

const repair = (
	rawCustomizationData: CustomizationItem[] | null | undefined,
	defaultMenuIds: string[],
) => repairItems(rawCustomizationData ?? [], createDefaultCustomizationItems(defaultMenuIds));
